import React from 'react';
import { useAuth } from '../../context/AuthContext';
import { Shirt } from 'lucide-react';

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, isLoading } = useAuth();

  // Show loading spinner while checking authentication
  if (isLoading) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-indigo-50 via-white to-purple-50 flex items-center justify-center">
        <div className="text-center">
          <div className="flex justify-center mb-6">
            <div className="w-16 h-16 bg-gradient-to-r from-indigo-600 to-purple-600 rounded-2xl flex items-center justify-center shadow-lg animate-pulse">
              <Shirt className="w-8 h-8 text-white" />
            </div>
          </div>
          <div className="space-y-4">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-indigo-600 mx-auto"></div>
            <p className="text-gray-600 font-medium">Loading BeyondXL Dashboard...</p>
          </div>
        </div>
      </div>
    );
  }

  // If user is authenticated, render the protected content
  if (isAuthenticated) {
    return children;
  }

  // If not authenticated, the App component will handle showing the login page
  return null;
};

export default ProtectedRoute; 